export default "__VITE_ASSET__CKI7tI0x__"